import { number } from '@amcharts/amcharts4/core';
import { BaseModel } from 'app/core/_base/crud';
export class DeNghiChuyenKhoModel extends BaseModel {
        Id: number
        SoPhieu: string
        NgayTao: string
        NguoiTao: number
        TenNguoiTao: string
        TrangThai: string
        PhongBanDeNghi: number
        TenPhongBan: string
        NgayChuyen: string
        LyDo: string
        TenPbKhac: string
        LoaiPhieuIn: string
        listDeNghiChuyenKhoCT:DeNghiChuyenKhoCTModel[]
        countChoDongAndChoDuyet:string
        clear() {
                this.Id = 0;
                this.SoPhieu = '';
                this.NgayTao = '';
                this.TenNguoiTao = '';
                this.TrangThai = '';
                this.PhongBanDeNghi = 0;
                this.TenPhongBan = '';
                this.NgayChuyen = '';
                this.LyDo = '';
                this.TenPbKhac = '';
                this.listDeNghiChuyenKhoCT=[];
                this.countChoDongAndChoDuyet='';
                this.NguoiTao = 0;
                this.LoaiPhieuIn = ''
        }
        copy(item: DeNghiChuyenKhoModel) {
                this.Id = item.Id;
                this.SoPhieu = item.SoPhieu;
                this.NgayTao = item.NgayTao;
                this.TenNguoiTao = item.TenNguoiTao;
                this.TrangThai = item.TrangThai;
                this.PhongBanDeNghi = item.PhongBanDeNghi;
                this.TenPhongBan = item.TenPhongBan;
                this.NgayChuyen = item.NgayChuyen;
                this.LyDo = item.LyDo;
                this.TenPbKhac = item.TenPbKhac;
                this.listDeNghiChuyenKhoCT=[];
                this.countChoDongAndChoDuyet=item.countChoDongAndChoDuyet;
                this.NguoiTao = item.NguoiTao;
                this.LoaiPhieuIn = item.LoaiPhieuIn;
        }
}
export class DeNghiChuyenKhoCTModel extends BaseModel {
        Id:number
        DaLapPhieuChuyenKho:boolean
        HangHoaId: number
        MaHang: string
        TenHang: string
        QuyCach: string
        TenDVT: string
        TenDVTQuiDoi: string
        KhoChuyen: number
        KhoNhan: number
        SLTon: number
        SoLuong: number
        SoLuongQuiDoi: number
        TextQuiDoiDVT: string
        ListHH: any[]

        SoLo: string
        SoMay: string
        SoMeSoXe: string
        MaThung: string
        GhiChu: string
        TenKhoChuyen: string
        TenKhoNhan: string
        SLThucXuat: number
        SLThucNhap: number
        // TenNguoiDuyet: string
        // NgayDuyet: string
        // TinhTrangCT: string
        // LyDo: string
        DataDuyet:DataDuyetModel
        Dvt:string
        DvtQuiDoi: number
        DeNghiChuyenKhoId:number
        TinhTrangPhieu:string
        DataDuyetCT:DataDuyetCT
        MaSub:string
        ListKhoChuyen: any[]
        ListChuyenKho: any[]
        Ngaysanxuat: string
        Hansudung:string
        isError: boolean
        messageError: string
        isDisableHH: boolean
        DvtCopy: number
        clear() {
                this.Id=0;
                this.DaLapPhieuChuyenKho=false;
                this.HangHoaId = 0;
                this.MaHang = '';
                this.TenHang = '';
                this.QuyCach = '';
                this.TenDVT = '';
                this.TenDVTQuiDoi = ''
                this.KhoChuyen = 0;
                this.KhoNhan = 0;
                this.SLTon = 0;
                this.SoLuong = 0;
                this.SoLo = '';
                this.SoMay = '';
                this.GhiChu = '';
                this.SoMeSoXe = '';
                this.TenKhoChuyen = '';
                this.TenKhoNhan = '';
                this.SLThucXuat = 0;
                this.SLThucNhap = 0;
                this.MaThung = '';
                // this.TenNguoiDuyet = '';
                // this.NgayDuyet = '';
                // this.TinhTrangCT = '';
                // this.LyDo = '';
                this.DataDuyet=null;
                this.Dvt='';
                this.DeNghiChuyenKhoId=0;
                this.TinhTrangPhieu='';
                this.DataDuyetCT=null;
                this.MaSub='';
                this.ListKhoChuyen = []
                this.Ngaysanxuat = ''
                this.Hansudung = ''
                this.isError = false;
                this.messageError = '';
                this.isDisableHH = false;
                this.DvtCopy = null
        }
        copy(item: DeNghiChuyenKhoCTModel) {
                this.Id=item.Id;
                this.DaLapPhieuChuyenKho=item.DaLapPhieuChuyenKho;
                this.HangHoaId = item.HangHoaId;
                this.MaHang = item.MaHang;
                this.TenHang = item.TenHang;
                this.QuyCach = item.QuyCach;
                this.TenDVT = item.TenDVT;
                this.TenDVTQuiDoi = item.TenDVTQuiDoi;
                this.KhoChuyen = item.KhoChuyen;
                this.KhoNhan = item.KhoNhan;
                this.SLTon = item.SLTon;
                this.SoLuong = item.SoLuong;
                this.SoLo = item.SoLo;
                this.SoMay = item.SoMay;
                this.MaThung = item.MaThung;
                this.GhiChu = item.GhiChu;
                this.SoMeSoXe = item.SoMeSoXe;
                this.TenKhoChuyen = item.TenKhoChuyen;
                this.TenKhoNhan = item.TenKhoNhan;
                this.SLThucXuat = item.SLThucXuat;
                this.SLThucNhap = item.SLThucNhap;
                // this.TenNguoiDuyet = item.TenNguoiDuyet;
                // this.NgayDuyet = item.NgayDuyet;
                // this.TinhTrangCT = item.TinhTrangCT;
                // this.LyDo = item.LyDo;
                this.DataDuyet=item.DataDuyet;
                this.Dvt=item.Dvt;
                this.DeNghiChuyenKhoId=item.DeNghiChuyenKhoId;
                this.TinhTrangPhieu=item.TinhTrangPhieu;
                this.DataDuyetCT=item.DataDuyetCT;
                this.MaSub=item.MaSub;
                this.ListKhoChuyen = item.ListKhoChuyen
                this.Ngaysanxuat = item.Ngaysanxuat
                this.Hansudung = item.Hansudung
                this.isError = item.isError
                this.messageError = item.messageError
                this.isDisableHH = item.isDisableHH
                this.DvtCopy = item.DvtCopy;
        }
}


export class DataDuyetModel extends BaseModel {
        TenNguoiDuyet: string
        NgayDuyet: string
        TinhTrangCT: string
        LyDo: string
       
        clear() {
                this.TenNguoiDuyet = '';
                this.NgayDuyet = '';
                this.TinhTrangCT = '';
                this.LyDo = '';
               
                
        }
        copy(item: DataDuyetModel) {
                this.TenNguoiDuyet = '';
                this.NgayDuyet = '';
                this.TinhTrangCT = '';
                this.LyDo = '';
        }
}

export class CtHangTonModel extends BaseModel {
        IdHh: string
        Tenhh: string
        Mahh: string
        Tenkho: string
        Makho: string
        Tinhtrang: boolean
        SoluongKDcXuat: string
        SoluongDcXuat:string
        clear() {
                this.IdHh = '';
                this.Tenhh = '';
                this.Mahh = '';
                this.Tenkho = '';
                this.Makho = '';
                this.Tinhtrang = false;
                this.SoluongKDcXuat = '';
                this.SoluongDcXuat='';
                
        }
        copy(item: CtHangTonModel) {
                this.IdHh = item.IdHh;
                this.Tenhh = item.Tenhh;
                this.Mahh = '';
                this.Tenkho = '';
                this.Makho = '';
                this.Tinhtrang = false;
                this.SoluongKDcXuat = item.SoluongKDcXuat;
                this.SoluongDcXuat=item.SoluongDcXuat;
        }
}


export class DataDuyetCT extends BaseModel {
        IsVisible_Duyet: boolean
        IsEnable_Duyet: boolean
       
       
        clear() {
                this.IsVisible_Duyet = false;
                this.IsEnable_Duyet = false;
                
               
                
        }
        copy(item: DataDuyetCT) {
                this.IsVisible_Duyet = item.IsVisible_Duyet;
                this.IsEnable_Duyet = item.IsEnable_Duyet;
               
        }
}


export class HistoryHHXuatKho extends BaseModel {
        Id_HH: string
        TenHH: string
        MaHH:string
        Id_LHH:string
        tenLoaiHH:string
        QuyCachDongGoi:string
        DVT1:string
        TenDVT1:string
        SoLo:string
        Soluongthucxuat:string
        Ngayxuat:string
        Sophieu:string
        Tinhtrang:string
        Tenkho:string
        ViTriKho:string
        SoMay:string
        MaSub:string
        clear() {
                this.Id_HH = '0';
                this.TenHH = '';
                this.MaHH='';
                this.Id_LHH='0'
               this.tenLoaiHH='';
               this.QuyCachDongGoi='';
               this.DVT1='0';
                this.TenDVT1='';
                this.SoLo='';
                this.Soluongthucxuat=''
                this.Ngayxuat='';
                this.Sophieu='';
                this.Tinhtrang='';
                this.Tenkho='';
                this.ViTriKho='';
                this.SoMay='';
                this.MaSub=''
        }
                
       
        copy(item: HistoryHHXuatKho) {
                this.Id_HH = item.Id_HH;
                this.TenHH = item.TenHH;
                this.MaHH=item.MaHH;
                this.Id_LHH=item.Id_LHH
               this.tenLoaiHH=item.tenLoaiHH;
               this.QuyCachDongGoi=item.QuyCachDongGoi;
               this.DVT1=item.DVT1;
                this.TenDVT1=item.TenDVT1;
                this.SoLo=item.SoLo;
                this.Soluongthucxuat=item.Soluongthucxuat
                this.Ngayxuat=item.Ngayxuat;
                this.Sophieu=item.Sophieu;
                this.Tinhtrang=item.Tinhtrang;
                this.Tenkho=item.Tenkho;
                this.ViTriKho=item.ViTriKho;
                this.SoMay=item.SoMay;
                this.MaSub=item.MaSub
        }
}


export class HistoryHHNhapKho extends BaseModel {
        Id_HH: string
        TenHH: string
        MaHH:string
        Id_LHH:string
        tenLoaiHH:string
        QuyCachDongGoi:string
        DVT1:string
        TenDVT1:string
        SoLo:string
        Soluongthucnhap:string
        Ngaynhapkho:string
        Sophieu:string
        Tinhtrang:string
        Tenkho:string
        ViTriKho:string
        SoMay:string
        MaSub:string
        clear() {
                this.Id_HH = '0';
                this.TenHH = '';
                this.MaHH='';
                this.Id_LHH='0'
               this.tenLoaiHH='';
               this.QuyCachDongGoi='';
               this.DVT1='0';
                this.TenDVT1='';
                this.SoLo='';
                this.Soluongthucnhap=''
                this.Ngaynhapkho='';
                this.Sophieu='';
                this.Tinhtrang='';
                this.Tenkho='';
                this.ViTriKho='';
                this.SoMay='';
                this.MaSub=''
        }
                
       
        copy(item: HistoryHHNhapKho) {
                this.Id_HH = item.Id_HH;
                this.TenHH = item.TenHH;
                this.MaHH=item.MaHH;
                this.Id_LHH=item.Id_LHH
               this.tenLoaiHH=item.tenLoaiHH;
               this.QuyCachDongGoi=item.QuyCachDongGoi;
               this.DVT1=item.DVT1;
                this.TenDVT1=item.TenDVT1;
                this.SoLo=item.SoLo;
                this.Soluongthucnhap=item.Soluongthucnhap
                this.Ngaynhapkho=item.Ngaynhapkho;
                this.Sophieu=item.Sophieu;
                this.Tinhtrang=item.Tinhtrang;
                this.Tenkho=item.Tenkho;
                this.ViTriKho=item.ViTriKho;
                this.SoMay=item.SoMay;
                this.MaSub=item.MaSub
        }
}